var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('z-steps',{attrs:{"active":0}},_vm._l((_vm.horizontal),function(item,index){return _c('z-step',{key:index,staticClass:"step",attrs:{"title":item.title,"image-active":item.imageActive,"image-deactive":item.imageDeactive}})}),1),_c('qua-form',{attrs:{"btnLoading":_vm.loading},on:{"handleSubmit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }